import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth'; //para la gestion de registro y login
import { first, map } from 'rxjs/operators';
import { auth } from 'firebase'; //API para proveedores de acceso que me da Firebase
import { LoginModalComponent } from '../login-modal/login-modal.component';
import { EventEmitterService } from './event-emitter.service';
import { DatabaseService } from './database.service';
import { FirebaseUserModel } from '../data-model/user.model';
import { ProfileTypes } from '../utilities';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  email = '';
  password = '';

  constructor(
    public afAuth: AngularFireAuth,
    private eventEmitterService: EventEmitterService,
    private dbService: DatabaseService,
    private route: Router
  ) { }

  user = this.afAuth.authState.pipe(map(authState => {
    console.log('authState: ', authState);
    if (authState) {
      return authState;
    } else {
      return null;
    }
  }));

  //Método 1 para saber si hay usuario autenticado
  getCurrentUser() {
    return this.afAuth.currentUser;
  }
  //Método 2 para saber si hay usuario autenticado
  getCurrentUserAlt() {
    return new Promise<firebase.User>((resolve, reject) => {
      var user = this.afAuth.onAuthStateChanged(function (user) {
        if (user) {
          resolve(user);
        } else {
          reject('No user logged in');
        }
      })
    })
  }
  //Método para autenticar y crear el usuario cuando se registra
  signup(user: FirebaseUserModel, pass) {
    return new Promise((resolve, reject) => {
      this.afAuth.createUserWithEmailAndPassword(user.email, pass) //Registro en el Authentication
      .then(userAuth => {
          console.log('user registrado con email: ', user);
          user.uid=userAuth.user.uid; //Le paso el uid que se genera el registro al usuario
          //this.eventEmitterService.onShowLoginModal(false);          
          this.dbService.getUser(userAuth.user.uid).get() //Comprobamos si el user ya existe en la BBDD
            .then(userDB => {
              if (!userDB.exists) { //Si no existe, entonces creamos el user en la BBDD
                this.dbService.createUpdateUser(userAuth.user.uid, user)
                  .then(() => {
                    resolve(true);
                  })
                  .catch(error => {
                    reject(error);
                  })
              }
              else resolve(true);
            })
            .catch(error => {
              reject(error);
            })
        })
        .catch(error => {
          console.log('error en email login: ', error);
          reject(error);
        })
    })

  }
  //Método para autenticar al usuario mediante email y contraseña
  login() {
    console.log('login!');
    this.afAuth.signInWithEmailAndPassword(this.email, this.password)
      .then(user => {
        console.log('user logueado con email: ', user);
        this.eventEmitterService.onShowLoginModal(false);
        // this.updateUserData(user.user);
      })
      .catch(error => {
        console.log('error en email login: ', error);
      })
  }
  //Método para autenticar al usuario mediante cuenta de Google
  glogin() {
    return new Promise((resolve, reject) => {
      console.log('google login!');
      this.afAuth.signInWithPopup(new auth.GoogleAuthProvider())
        .then(user => {
          this.eventEmitterService.onShowLoginModal(false);
          this.dbService.getUser(user.user.uid).get().then(data => {
            var userdata = data.data();
            if (!userdata) {
              var userToCreate = new FirebaseUserModel();
              userToCreate.name = user.user.displayName || '';
              userToCreate.lastname = '';
              userToCreate.email = user.user.email || '';
              userToCreate.nickname = '';
              userToCreate.profile = ProfileTypes.Estandar;
              this.dbService.createUpdateUser(user.user.uid, userToCreate)
                .then(() => {
                  resolve(true);
                })
                .catch(error => {
                  reject(error);
                });
            }
          });
        })
        .catch(error => {
          console.log('error en google login: ', error);
          reject(error);
        });
    });
  }
  //Método para cerrar sesión del usuario
  logout() {
    console.log('logout!');
    this.afAuth.signOut();
    this.email = '';
    this.password = '';
    this.route.navigate(['/inicio']);
  }

}
